import { BaseTrackingEvent as _BaseTrackingEvent } from "./model/BaseTrackingEvent";
export var TrackingEventAmbientRegistry;
(function (TrackingEventAmbientRegistry) {
    TrackingEventAmbientRegistry.BaseTrackingEvent = _BaseTrackingEvent;
})(TrackingEventAmbientRegistry || (TrackingEventAmbientRegistry = {}));
//# sourceMappingURL=TrackingEventAmbientRegistry.js.map